import { useEffect, useRef, useCallback } from 'react';

export const useResizeObserver = (callback: () => void, targetRef?: React.RefObject<HTMLDivElement>) => {
  const internalRef = useRef<HTMLDivElement>(null);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  // Use provided ref or internal ref
  const activeRef = targetRef || internalRef;

  const updateSize = useCallback(callback, [callback]);

  useEffect(() => {
    if (!activeRef.current) return;

    // Initial measurement
    updateSize();

    // Use ResizeObserver for better performance
    if (window.ResizeObserver) {
      resizeObserverRef.current = new ResizeObserver(updateSize);
      resizeObserverRef.current.observe(activeRef.current);
    } else {
      // Fallback to window resize for older browsers
      window.addEventListener('resize', updateSize);
    }

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      } else {
        window.removeEventListener('resize', updateSize);
      }
    };
  }, [updateSize, activeRef]);

  return activeRef;
};
